import React, { useState } from "react"
import PropTypes from "prop-types"
import { Paper } from "@material-ui/core"
import Button from "@mui/material/Button"
import { HelveticaBold } from "common/typographies"
import ModalIntegrationsSettings from "./ModalIntegrationsSettings"
import i18n from "i18n"

const IntegrationsSection = ({ organizationFields }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Paper elevation={0} style={{ padding: "16px", height: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flex: 1 }}>
            <HelveticaBold
              style={{ fontSize: "18px", color: "#414141", marginBottom: 8 }}
            >
              {i18n.t("integrationsSettings.title")}
            </HelveticaBold>
            <div style={{ color: "#6d6d6d", fontSize: "14px", marginTop: 4 }}>
              {i18n.t("integrationsSettings.description")}
            </div>
          </div>
          <Button
            variant="contained"
            color="branded"
            style={{ marginLeft: 24, minWidth: 120 }}
            onClick={() => setOpen(true)}
          >
            {i18n.t("integrationsSettings.configure")}
          </Button>
        </div>
      </Paper>
      <ModalIntegrationsSettings
        open={open}
        onClose={() => setOpen(false)}
        organizationFields={organizationFields}
      />
    </>
  )
}

export default IntegrationsSection

IntegrationsSection.propTypes = {
  organizationFields: PropTypes.object.isRequired,
}
